import React, { useEffect, useMemo, useState } from 'react'
import { Form, OverlayTrigger, Popover } from 'react-bootstrap'
import './timepicker-custom-styles.css'

import InputMask from 'react-input-mask'
import TimePickerCustom from './TimePickerCustom'
import dayjs from 'dayjs'
import FeatherIcon from 'feather-icons-react'
import { useTimeFormat } from 'contexts/TimeFormatContext'
import {
  getTimeInputValue,
  INVALID_DATE_TIME_VALUE,
} from 'designer/component/validation/dateTime'

const TimePickerInput = ({
  value,
  onChange,
  readOnly,
  formatDisplay,
  ampm,
  id,
  name,
  isTable,
  uischema,
  validateInput = false,
  ...props
}) => {
  let { formatTime } = useTimeFormat()
  let regexAlphabet = /^[a-zA-Z]+$/
  const convertTime = (time, format = 'HH:mm:ss') => {
    if (time) {
      const date = dayjs(time)
      if (date.isValid()) {
        return date.format(format)
      } else {
        return ''
      }
    } else {
      return ''
    }
  }

  const [timeValue, setTimeValue] = useState(
    value ? convertTime(value, formatDisplay) : ''
  )
  const [showPicker, setShowPicker] = useState(false)

  const handleChangeTime = (newValue, isPicker = false) => {
    let dateDefault = dayjs().format('YYYY-MM-DD')
    let timeDefault = isPicker || !validateInput
      ? convertTime(`${dateDefault} ${newValue}`)
      : getTimeInputValue(newValue, formatDisplay)
    setTimeValue(newValue)
    if (onChange) {
      onChange(timeDefault)
    }
  }

  const handleTogglePicker = () => {
    setShowPicker(!showPicker)
  }

  const timePicker = (time) => {
    return (
      <Popover className="popover-timepicker">
        <Popover.Content>
          <TimePickerCustom
            value={time}
            onChange={(value) => handleChangeTime(value, true)}
            onClose={handleTogglePicker}
            formatDisplay={formatDisplay}
            ampm={ampm}
            timeValue={timeValue}
            setTimeValue={setTimeValue}
            convertTime={convertTime}
          />
        </Popover.Content>
      </Popover>
    )
  }

  const formatToMask = (formatDsp = '') => {
    let mask = formatDsp.split('').reduce((items, item) => {
      if (item === 'A') {
        items += 'aa'
      } else if (regexAlphabet.test(item)) {
        items += 9
      } else {
        items += item
      }
      return items
    }, '')
    return mask
  }

  let maskInput = useMemo(() => formatToMask(formatDisplay), [formatDisplay])

  useEffect(() => {
    if (value === INVALID_DATE_TIME_VALUE) return
    if ((value && !timeValue) || (timeValue && value !== timeValue)) {
      let dateDefault = dayjs().format('YYYY-MM-DD')
      let timeDefault = convertTime(`${dateDefault} ${value}`)
      setTimeValue(timeDefault)
    }
  }, [value])

  if (readOnly && uischema) {
    let format = uischema?.timeFormat || ''
    let dateDefault = dayjs().format('YYYY-MM-DD')
    let time = formatTime(`${dateDefault} ${timeValue}`, format)
    return isTable ? (
      time
    ) : (
      <Form.Control readOnly id={id} name={name} value={time} />
    )
  }

  return (
    <>
      <InputMask
        value={timeValue}
        className="form-control"
        placeholder={formatDisplay}
        mask={maskInput}
        maskChar={null}
        readOnly={readOnly}
        onChange={(e) => handleChangeTime(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            setShowPicker(false)
          }
        }}
        {...props}
      />
      {timeValue && !readOnly && (
        <button
          className="clear-time-btn"
          style={{ width: 0 }}
          onClick={() => handleChangeTime('')}
        >
          <FeatherIcon className={'text-secondary'} icon="x" size="20" />
        </button>
      )}
      {!readOnly && (
        <OverlayTrigger
          trigger="click"
          placement="bottom"
          overlay={timePicker(value)}
          rootClose={true}
          show={showPicker} // Controlled by state
          onToggle={(nextShow) => setShowPicker(nextShow)}
        >
          <button className="clock-btn" onClick={handleTogglePicker}>
            <FeatherIcon className={'text-secondary'} icon="clock" size="24" />
          </button>
        </OverlayTrigger>
      )}
    </>
  )
}

export default TimePickerInput
